module.exports = __webpack_public_path__ + "static/media/4.2f75414a.jpg";